import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import BuyerRoom from '../../components/Succession/BuyerRoom/BuyerRoom';
import getMessages from '../../lib/i18n/getMessages';
import { CurrencyProvider } from '../../hooks/useCurrency';

const BuyerRoomContainer = ({ currentUser, company, deal, dealInterest, dealName }, railsContext) => {
  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  window.currency = (railsContext && railsContext.currency) || window.currency || 'USD';
  const locale = window.locale;
  
  // Debug logging
  console.log("=== BUYER ROOM CONTAINER DEBUG ===");
  console.log("Props received:", { currentUser, company, deal, dealInterest, dealName });
  console.log("Deal exists:", !!deal);
  console.log("DealInterest exists:", !!dealInterest);
  
  // Validation
  if (!deal || !dealInterest) {
    console.log("Validation failed - showing error page");
    console.log("Deal missing:", !deal);
    console.log("DealInterest missing:", !dealInterest);
    
    return (
      <CurrencyProvider currency={(railsContext && railsContext.currency) || window.currency || 'USD'}>
        <IntlProvider locale={locale} messages={getMessages(locale)}>
          <div className="min-h-screen bg-gray-50 flex items-center justify-center">
            <div className="text-center">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <h3 className="mt-2 text-lg font-medium text-gray-900">Deal not found</h3>
              <p className="mt-1 text-sm text-gray-500">
                You don't have access to this deal or it doesn't exist.
              </p>
              <div className="mt-4 text-xs text-gray-400">
                Debug: Deal={deal ? 'exists' : 'missing'}, DealInterest={dealInterest ? 'exists' : 'missing'}
              </div>
              <button
                onClick={() => window.location.href = '/succession/buyer_deals'}
                className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
              >
                Back to My Deals
              </button>
            </div>
          </div>
        </IntlProvider>
      </CurrencyProvider>
    );
  }

  console.log("Validation passed - rendering BuyerRoom component");

  return (
    <CurrencyProvider currency={(railsContext && railsContext.currency) || window.currency || 'USD'}>
      <IntlProvider locale={locale} messages={getMessages(locale)}>
        <BuyerRoom
          currentUser={currentUser}
          company={company}
          deal={deal}
          dealInterest={dealInterest}
          dealName={dealName}
          loading={false}
          cashFlows={[]}
        />
      </IntlProvider>
    </CurrencyProvider>
  );
};

BuyerRoomContainer.propTypes = {
  currentUser: PropTypes.object.isRequired,
  company: PropTypes.object.isRequired,
  deal: PropTypes.object,
  dealInterest: PropTypes.object,
  dealName: PropTypes.string.isRequired
};

export default BuyerRoomContainer; 